module.exports = __webpack_public_path__ + "static/media/Col3a.aadddadc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Col3a.png
// module id = 31
// module chunks = 0